import { validateMutationForm } from 'toolbox';
import { makeMutationForm } from 'components/makeMutationForm/makeMutationForm';

export const LiquidityLimitForm = makeMutationForm<{
  id: number;
  organisation_id: number;
  notice_days_gte: number;
  notice_days_lt: number;
  lower_limit_pct: number;
  upper_limit_pct: number;
}>({
  config: {
    id: { type: 'hidden' },
    organisation_id: { type: 'hidden' },
    notice_days_gte: { type: 'hidden' },
    notice_days_lt: { type: 'hidden' },
    lower_limit_pct: { type: 'number' },
    upper_limit_pct: { type: 'number' },
  },
  validate: (values) => {
    if (Number(values.upper_limit_pct) <= Number(values.lower_limit_pct)) {
      return {
        upper_limit_pct: 'Upper limit must be greater than lower limit',
        lower_limit_pct: 'Lower limit must be less than upper limit',
      };
    }
    if (
      Number(values.upper_limit_pct) > 100 ||
      Number(values.upper_limit_pct) < 1
    ) {
      return {
        upper_limit_pct: 'Upper limit must be between 1 and 100%',
      };
    }
    if (
      Number(values.lower_limit_pct) > 99 ||
      Number(values.lower_limit_pct) < 0
    ) {
      return {
        upper_limit_pct: 'Lower limit must be between 0 and 99%',
      };
    }
    return validateMutationForm({
      config: {
        organisation_id: ['required'],
        lower_limit_pct: ['required'],
        upper_limit_pct: ['required'],
      },
      values,
    });
  },
});
